import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Select from 'components/Shared/Select/Index'
import FilterTitle from './FilterTitle'

const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: 1px solid ${colors.secondary70};
`

const StyledSelect = styled(Select)`
  && {
    margin: 0 10px 10px 9px;
    width: auto;
    height: 30px;
    font-size: 14px;
  }
`

const FilterSectionSelect = ({
  title, name, value, onChange, options, iconComponentsMap,
}) => {
  const active = !!value
  const [value_, setValue_] = useState(value)
  const isEmpty = !value_

  useEffect(() => {
    setValue_(value)
  }, [value])

  const onActiveChange = (newActive) => {
    applyChanges(newActive ? value_ : null)
  }

  const onInputChange = (newValue) => {
    setValue_(newValue)
    if (active) {
      applyChanges(newValue)
    }
  }

  const applyChanges = (newValue) => {
    onChange?.({
      value: newValue,
      name: name,
    })
  }

  return (
    <StyledWrapper data-test={name}>
      <FilterTitle
        disabled={isEmpty}
        active={active}
        title={title}
        onActiveChange={onActiveChange}
      />
      <StyledSelect
        small
        value={value_}
        onChange={onInputChange}
        options={options}
        iconComponentsMap={iconComponentsMap}
      />
    </StyledWrapper>
  )
}

FilterSectionSelect.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  iconComponentsMap: PropTypes.object,
}

export default FilterSectionSelect
